import { CATALYST_COLORS_WITH_HEXCODES } from "@certa/catalyst/constants/styles";
import { BoxNode } from "../engines/renderingEngine/primitiveNodes";
import type { NodeStyle } from "../engines/layoutEngine/layout.types";

export const HORIZONTAL_DROP_INDICATOR_HEIGHT = 2;

export const HorizontalDropIndicator = () => {
  return BoxNode({
    key: "HorizontalDropIndicator",
    style: horizontalDropIndicatorStyle,
    children: []
  });
};

const horizontalDropIndicatorStyle: Partial<NodeStyle> = {
  width: "100%",
  height: HORIZONTAL_DROP_INDICATOR_HEIGHT,
  backgroundColor: CATALYST_COLORS_WITH_HEXCODES.NEUTRAL_800
};
